import { Box, Button, CircularProgress, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import { getProspectusVisitsDetails, getVisitsDetails } from '_controllers/officer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';

const messageStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#ffffff',
    border: "none",
    boxShadow: 24,
    pt: 2,
    pb: 0,
    pl: 4,
    pr: 4,
    textAlign: 'left',
    letterSpacing: 1
};

const ProspectusVisits = () => {
    const { SAP_ID } = useParams();
    const url = process.env.REACT_APP_REQUEST_ENDPOINT

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [visitDetails, setVisitDetails] = useState([])
    const [message, setMessage] = useState("");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [csvData, setCsvData] = useState([]);
    const [prospectVisit, setProspectVisit] = useState(true)
    const [customerVisit, setCustomerVisit] = useState(false)
    const [customerVisitData, setCustomerVisitData] = useState([])
    const [influencerVisit, setInfluencerVisit] = useState(false)
    const [influencerVisitData, setInfluencerVisitData] = useState([])

    const [Values, setValues] = useState({
        selectStartDate: '',
        selectEndDate: '',
    });

    const { selectStartDate, selectEndDate } = Values

    const timeSpent = (a, b) => {
        const test = moment.duration(moment(b ? b : "").diff(moment(a ? a : "")))
        return `${test.asMinutes().toFixed(0)} mins`;
    };

    useEffect(async () => {
        const start = startDate
            ? startDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = endDate
            ? endDate
            : moment().endOf("month").format("YYYY-MM-DD");
        const plan = await getProspectusVisitsDetails({
            SAP_ID,
            start,
            end,
        });
        console.log("gyp", plan?.data);
        setData(plan?.data);
        setCsvData(plan?.data)
        setLoading(true);
    }, [message, startDate, endDate]);

    const token = localStorage.getItem("token");
    const config = {
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    }


    useEffect(async () => {
        const start = selectStartDate
            ? selectStartDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = selectEndDate
            ? selectEndDate
            : moment().endOf("month").format("YYYY-MM-DD");

        await axios.get(
            `${url}/api/v1/visit/customer/dash?userId=${SAP_ID}&endDate=${end ? end : ""}&startDate=${start ? start : ""
            }`,
            config
        ).then((res) => {
            console.log("res", res);
            setCustomerVisitData(res?.data?.data)
        }).catch((err) => {
            console.log("err", err);
            // setMessage(err?.message)
        });
    }, [message, selectStartDate, selectEndDate]);

    useEffect(async () => {
        const start = selectStartDate
            ? selectStartDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = selectEndDate
            ? selectEndDate
            : moment().endOf("month").format("YYYY-MM-DD");

        await axios.get(
            `${url}/api/v1/visit/influencer/dash?userId=${SAP_ID}&endDate=${end ? end : ""}&startDate=${start ? start : ""
            }`,
            config
        ).then((res) => {
            console.log("res", res);
            setInfluencerVisitData(res?.data?.data)
        }).catch((err) => {
            console.log("err", err);
            // setMessage(err?.message)
        });
    }, [message, selectStartDate, selectEndDate]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setValues({ ...Values, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const plan = await getProspectusVisitsDetails({
            SAP_ID,
            start: selectStartDate,
            end: selectEndDate,
        });
        console.log("gyp", plan?.data);
        setData(plan?.data);
        setCsvData(plan?.data)
        setLoading(true);
    }



    const fileName = `${SAP_ID}-Prospect_Visits`;

    const generateExcel = async (e) => {
        e.preventDefault()
        const visitact = []

        exportExcel(csvData.map((x) => {
            return {
                'SAP ID': x?.SAP_ID,
                'Lead Type': x?.prospectusId?.basicDetail?.leadType,
                "Firm Name": x?.prospectusId?.basicDetail?.firmName,
                'Firm Type': x?.prospectusId?.basicDetail?.natureOfFirm ? x?.prospectusId?.basicDetail?.natureOfFirm : "-",
                "Plan Date": moment(x?.startTime).format('DD-MM-YYYY'),
                "Status": x?.completed ? "Completed" : "Pending",
                'Start Time': moment.utc(x.startTime).format("HH:mm"),
                'End Time': moment.utc(x.endTime).format("HH:mm"),
                // 'Completed': x?.completed,
                "Time Spent (mins)": moment.duration((moment(x.endTime ? x.endTime : "")).diff((moment(x.startTime ? x.startTime : "")))).asMinutes().toFixed(0),
                "Remarks": x?.remark,
            }
        }), fileName)
    }

    console.log("tets", prospectVisit, influencerVisitData, customerVisitData);

    return (
        <>
            {/* // change static data in url endpoint*/}
            <Box sx={{ mt: 2 }}>
                <form onSubmit={handleSubmit}>
                    <Grid container xs={12} sx={{ m: 1 }}>
                        <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={3}>
                                <h5>Start Date :</h5>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    type={'date'}
                                    sx={{ width: '80%' }}
                                    onChange={handleChange}
                                    value={selectStartDate}
                                    name="selectStartDate"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <Grid container xs={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Grid item xs={3}>
                                <h5>End Date :</h5>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    type={'date'}
                                    sx={{ width: '80%' }}
                                    onChange={handleChange}
                                    value={selectEndDate}
                                    name="selectEndDate"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={2} style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                            <FilterAltOutlinedIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={handleSubmit} />
                            <DownloadIcon sx={{ border: '1px solid darkgrey', fontSize: '45px', borderRadius: '3px', cursor: 'pointer' }} onClick={generateExcel} />
                        </Grid>
                    </Grid>
                </form>
            </Box>

            <Box style={{ marginTop: "1rem" }}>
                <Button
                    onClick={() => {
                        setProspectVisit(true)
                        setInfluencerVisit(false)
                        setCustomerVisit(false)
                    }}
                    variant={prospectVisit ? "contained" : "outlined"}
                >
                    Prospect Visits
                </Button>
                <Button
                    onClick={() => {
                        setProspectVisit(false)
                        setInfluencerVisit(true)
                        setCustomerVisit(false)
                    }}
                    variant={influencerVisit ? "contained" : "outlined"}
                    sx={{ ml: 5 }}
                >
                    Influencer Visits
                </Button>
                <Button
                    onClick={() => {
                        setProspectVisit(false)
                        setInfluencerVisit(false)
                        setCustomerVisit(true)
                    }}
                    variant={customerVisit ? "contained" : "outlined"}
                    sx={{ ml: 5 }}
                >
                    Customer Visits
                </Button>
            </Box>
            {loading ? (
                <>
                    <TableContainer component={Paper} sx={{ mt: 3, mb: 2.5 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Date</TableCell> */}
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Firm Name</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Visit Date</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Lead Type</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Firm Nature</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Status</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Time Spent</TableCell>
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Remark</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                prospectVisit ? (data?.length > 0
                                    ? data?.map((d) => (
                                        <TableBody>
                                            <TableRow key={d._id}>
                                                <TableCell align="left">{d?.prospectusId?.basicDetail?.firmName}</TableCell>
                                                <TableCell align="left">{moment.utc(d?.startTime).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell align="left">{d?.prospectusId?.basicDetail?.leadType}</TableCell>
                                                <TableCell align="left">{d?.prospectusId?.basicDetail?.natureOfFirm ? d?.prospectusId?.basicDetail?.natureOfFirm : "-"}</TableCell>
                                                <TableCell align="left">{d?.completed ? "Completed" : "Pending"}</TableCell>
                                                <TableCell
                                                    align="left"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}
                                                </TableCell>
                                                <TableCell align="left">{d?.remark}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )) :
                                    <Box sx={{ textAlign: 'left', pt: 1 }}>
                                        <Typography variant="h6" sx={{ p: 1 }}>No Prospect Visits Available.</Typography>
                                    </Box>
                                ) : (
                                    influencerVisit ? (
                                        influencerVisitData?.length > 0 ?
                                            influencerVisitData.map((d) => (
                                                <TableBody>
                                                    <TableRow key={d._id}>
                                                        <TableCell align="left">{d?.influencerId?.name}</TableCell>
                                                        <TableCell align="left">{moment.utc(d?.startTime).format('DD-MM-YYYY')}</TableCell>
                                                        <TableCell align="left">{"NA"}</TableCell>
                                                        <TableCell align="left">{"NA"}</TableCell>
                                                        <TableCell align="left">{d?.completed ? "Completed" : "Pending"}</TableCell>
                                                        <TableCell
                                                            align="left"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}
                                                        </TableCell>
                                                        <TableCell align="left">{d?.remark}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )) :
                                            <Box sx={{ textAlign: 'left', pt: 1 }}>
                                                <Typography variant="h6" sx={{ p: 1 }}>No Influencer Visits Available.</Typography>
                                            </Box>
                                    ) : (
                                        customerVisitData?.length > 0 ?
                                            customerVisitData.map((d) => (
                                                <TableBody>
                                                    <TableRow key={d._id}>
                                                        <TableCell align="left">{d?.customerId?.businessDetails?.firmName}</TableCell>
                                                        <TableCell align="left">{moment.utc(d?.startTime).format('DD-MM-YYYY')}</TableCell>
                                                        <TableCell align="left">{"NA"}</TableCell>
                                                        <TableCell align="left">{d?.customerId?.businessDetails?.businessType ? d?.customerId?.businessDetails?.businessType : "-"}</TableCell>
                                                        <TableCell align="left">{d?.completed ? "Completed" : "Pending"}</TableCell>
                                                        <TableCell
                                                            align="left"
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}
                                                        </TableCell>
                                                        <TableCell align="left">{d?.remark}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )) :
                                            <Box sx={{ textAlign: 'left', pt: 1 }}>
                                                <Typography variant="h6" sx={{ p: 1 }}>No Customer Visits Available.</Typography>
                                            </Box>
                                    )
                                )
                            }
                            {/* <Box sx={{ textAlign: 'left', pt: 1 }}>
                                <Typography variant="h6" sx={{ p: 1 }}>No Prospect Visit's Available.</Typography>
                            </Box>) */}

                        </Table>
                    </TableContainer>
                </>
            ) : (
                <CircularProgress />
            )}
            <Modal open={open} onClose={handleClose}>
                <Box sx={messageStyle}>
                    <Table aria-label="simple table">
                        <TableHead >
                            <TableRow >
                                <TableCell align='left' sx={{ fontWeight: 'bolder' }}>Type</TableCell>
                                <TableCell sx={{ fontWeight: 'bolder' }}>Action Taken</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {visitDetails?.length > 0 ? (
                                visitDetails.map((row) => (
                                    <TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="left" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.type}</TableCell>
                                        <TableCell align="center" scope="row" style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>{row?.actionTaken}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow key={'1'} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell colSpan={3} align="center">
                                        No Visit Action Available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Box sx={{ m: 3, display: 'flex', justifyContent: 'center' }}>
                        <Button variant="contained" onClick={() => setOpen(false)}>Close</Button>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}

export default ProspectusVisits